import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { CompanyLogoService } from '@wealthlane/api-services/wealthlane-customer-service';

const useDeleteCompanyProfileLogo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void
): UseMutationResult<boolean | undefined, unknown, void, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async () => {
      return await handleRequest(
        CompanyLogoService.deleteApiCustomerApiAppCompanyLogoCompanyLogo()
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null && response !== false) {
          await queryClient.invalidateQueries('getProfileImage');
          toast.success(<ToastComponent label='Success' message='Company Logo Removed' />);
          onClose && onClose();
        }
      },
      onError: (err) => {
        console.log('error', err);
        onClose && onClose();
      },
    }
  );
};

export default useDeleteCompanyProfileLogo;
